module.exports = require("docxtemplater");